import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { TemplatesService } from '../templates.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedService } from '../../../shared/shared.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Logger } from 'angular2-logger/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject} from 'rxjs';
import { MatTableModule } from '@angular/material/table';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import {PageEvent} from '@angular/material/paginator';
import { Observable } from 'rxjs/Observable';
import { of as observableOf } from 'rxjs/observable/of';
import { pipe } from 'rxjs/util/pipe';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';

// import * as $ from 'jquery';
//Jquery
declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-templates-list',
    templateUrl: './templates-list.component.html',
    styleUrls: ['../../admin/admin.component.scss','./templates-list.component.scss']
})
export class TemplatesListComponent implements OnInit
    {
        @ViewChild(MatSort) sort: MatSort;
        public dataSource = new MatTableDataSource();
        @ViewChild(MatPaginator) paginator: MatPaginator;

    pageEvent: PageEvent;

    public templates:any[];
    public total_items: number;
    public actualPage: number = 0;
    public pag_size: any;
    public pag_number: any;
    public list: any;
    public itemQuantity = [];
    public on_button = false;
    public del_status: string;
    public text_delete: any;

    public template_id: any;
    public detalle_plantilla: any;
    public variables: any;

    public filter: FormGroup;

    public ngOptions = ['Texto', 'Número', 'Fecha'];
    public ngDropdown = 'Texto';

    public arraySel = [];

    public valorHtml: any;

    public dataExcel : any;
    public idChannel : any;

    public countries = ['Select one:',
    'United States',
    'Canada',
    ];

    public displayedColumns = [
        'template_id',
        'description_template',
        'content_template',
        'created_at',
        'ver',
        'editar'
    ];

    public searchTerm$ = new Subject<string>();
    
    constructor(
        private _templatesService: TemplatesService,
        private spinner: NgxSpinnerService,
        private _sharedService: SharedService,
        public toastr: ToastsManager,
        private _router: Router,
        private logger: Logger,
        private fb: FormBuilder,
    ) {
        this.pag_size = 5;
        this.pag_number = 1;
        this.filter = this.fb.group({
            textoFiltro: []
        });
    }


    ngAfterViewInit() {
        this.paginator.pageSize = this.pag_size;
        this.getTemplates();
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); 
        filterValue = filterValue.toLowerCase(); 
        this.dataSource.filter = filterValue;
    }

    ngOnInit() {
        this.dataSource.paginator = this.paginator;
        let data = {
            auth_token: this._sharedService.getCookie("auth_token"),
            page: this.pag_number,
            pageSize: this.pag_size
        };

        this._templatesService.getTemplates(data).subscribe(
            data => {
                
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );

        this.updatePage();
    }

    updatePage() {
        this.dataExcel = [];
        this. idChannel = '';

        this.spinner.show();

        let data = {
            auth_token: this._sharedService.getCookie("auth_token"),
            limit: this.pag_size, 
            page: this.pag_number  
        };
        this._templatesService.validateIdChannel(data).subscribe(
            data=>{
                this.idChannel = data.idChannel;
                console.log(this.idChannel);
            },
            error => { 
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );
        this._templatesService.getlistTemplate(data).subscribe(
            data => {
                this.spinner.hide();
                if (data.status) { 
                    this.dataSource=data.data.data;
                    this.list = data.data.data; 

                    for (let i in this.list) {
                        let tempExcel = [];
                        tempExcel['Id'] = this.list[i].template_id;
                        tempExcel['Nombre plantilla'] = this.list[i].description_template;
                        tempExcel['Contenido plantilla'] = this.list[i].content_template;
                        tempExcel['Fecha'] = this.list[i].created_at;
                        tempExcel['Estado'] = this.list[i].status == '0' ? 'Habilitado' : 'Inhabilitado';

                        this.dataExcel.push(tempExcel);
                    } 

                    this.total_items = data.data.total;
                    this.itemQuantity = Array(data.data.last_page).fill(0).map((x, i) => i + 1);
                } else { // API error
                    this.toastr.error(data.message, 'Error');
                }

            },
            error => { //server error
                //this.load = false;
                this.spinner.hide();
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                this.logger.log(error);
            }
        );
    }

    exportAsXLSX(): void {
        this._templatesService.exportAsExcelFile(this.dataExcel, 'reporte');
    }

    modalDelete(id) {

        if (id) {

            //this.load = true; // loading screen
            this.spinner.show();
            this.text_delete = true;

            let data = {
                auth_token: this._sharedService.getCookie('auth_token'), // get cookie
                id: id
            };

            this._templatesService.deleteTags(data).subscribe(
                data => {
                    if (data.status) {
                        console.log(data);
                        if (data.message == 'deletedFailTags') {
                            this.toastr.error('La etiqueta está asociada a una conversación', 'Error');
                        } else {
                            this.toastr.success('La etiqueta ha sido eliminada', '¡Éxito!');
                            this.updatePage();
                        }
                    } else {
                        this.toastr.error(data.message, 'Error');
                    }

                    //this.load = false;
                    this.spinner.hide();
                    this.text_delete = false;
                },
                error => {
                    this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                    //this.load = false;
                    this.spinner.hide();
                    this.logger.log(error);
                }
            );
        }
    }

    onEdit() {
        
    }

    verPlantilla(id: number) {
        this.arraySel = [];
        this.template_id = id;
        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            template_id: this.template_id
        };
        this.spinner.show();

        this._templatesService.getTemplateId(data).subscribe(
            data => {
                if (data.status) {
                    this.detalle_plantilla = data.data.detalle;
                    this.variables = data.data.variables;
                    $('#DeleteUser').modal('toggle');

                } else {
                    this.toastr.error(data.message, 'Error');
                }

                //this.load = false;
                this.spinner.hide();
                this.text_delete = false;
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );
    }

    onChange(deviceValue, valor) {
        var obj = {
            valor: valor,
            template_id: this.template_id,
            type: deviceValue
        };
        this.arraySel.push(obj);
    }

    changeType() {
        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            variables: this.arraySel
        };
        this.spinner.show();

        this._templatesService.changeTemplateType(data).subscribe(
            data => {
                if (data.status) {
                    this.updatePage();
                } else {
                    this.toastr.error(data.message, 'Error');
                }

                //this.load = false;
                this.spinner.hide();
                this.text_delete = false;
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );
    }

    onDelete(id: string) {

        $('#DeleteUser').modal('toggle');

        this.on_button = true;

        this.del_status = id;
    }

    filterTemplate() {
        console.log(this.filter.value.textoFiltro);
        let data = {
            auth_token: this._sharedService.getCookie('auth_token'),
            filter: this.filter.value.textoFiltro,
            limit: this.pag_size, // quantity of items
            page: this.pag_number  // page
        };

        this.spinner.show();

        this._templatesService.filterTemplates(data).subscribe(
            data => {
                console.log(data.data);
                if (data.status) {
                    this.list = data.data.templates; //data list
                    this.total_items = data.data.countTemplates;
                    //this.itemQuantity = Array(data.data.last_page).fill(0).map((x, i) => i + 1);
                } else {
                    this.toastr.error(data.message, 'Error');
                }

                //this.load = false;
                this.spinner.hide();
                this.text_delete = false;
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );
    }



    getTemplates() {
        if (this.paginator) {
            
            this.paginator.page
            .pipe(
                startWith({}),
                switchMap(() => {
                    const data = {
                        page: this.paginator.pageIndex + 1,
                        limit: this.pag_size,
                        auth_token: this._sharedService.getCookie("auth_token")  
                    };
                    console.log("Limit Data:", data.limit);
                    return this._templatesService.getlistTemplate(data).pipe(catchError(() => observableOf(null)));
                }),
                map((empData) => {
                    console.log("empData", empData['data']['total']);
                    console.log("Paginator Data: ",this.paginator);
                    if (empData == null) return [];  
                    this.paginator.length = empData['data']['total'];
                    return empData['data']['data'];
                })
            )
            .subscribe((empData) => {
                this.templates = empData;
                this.dataSource = new MatTableDataSource(this.templates);
                
            });
        }

    }  

    enableTemplate(id: number, status: number) {
        this.template_id = id

        let data = {
            auth_token: this._sharedService.getCookie('auth_token'), // get cookie
            template_id: this.template_id,
            status: status
        };
        this.spinner.show();


        this._templatesService.changeTemplateStatus(data).subscribe(
            data => {
                if (data.status) {
                    
                    this.getTemplates();
                    
                } else {
                    this.toastr.error(data.message, 'Error');
                }

                this.spinner.hide();
                this.text_delete = false;
            },
            error => {
                this.toastr.error('Ocurrió un error, inténtalo de nuevo', 'Error');
                //this.load = false;
                this.spinner.hide();
                this.logger.log(error);
            }
        );
    }

}






// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/templates/templates-list/templates-list.component.ts